window.GALLERY = {
  "cities": [
    {
      "type": "image",
      "src": "assets/gallery/cities-00.jpg"
    },
    {
      "type": "video",
      "src": "assets/cities-video.mp4"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-02.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-03.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-04.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-05.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-06.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-07.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-08.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-09.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-10.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-11.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-12.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-13.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-14.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-15.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-16.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-17.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-18.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-19.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-20.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-21.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-22.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-23.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-24.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-25.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-26.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-27.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-28.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-29.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/cities-30.jpg"
    }
  ],
  "nature": [
    {
      "type": "image",
      "src": "assets/gallery/nature-00.jpg"
    },
    {
      "type": "video",
      "src": "assets/nature-video.mp4"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-02.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-03.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-04.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-05.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-06.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-07.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-08.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-09.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-10.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-11.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-12.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-13.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-14.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-15.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-16.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-17.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-18.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-19.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-20.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-21.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-22.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-23.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/nature-24.jpg"
    }
  ],
  "wildlife": [
    {
      "type": "image",
      "src": "assets/gallery/wildlife-00.jpg"
    },
    {
      "type": "video",
      "src": "assets/wildlife-video.mp4"
    },
    {
      "type": "image",
      "src": "assets/gallery/wildlife-02.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/wildlife-03.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/wildlife-04.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/wildlife-05.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/wildlife-06.jpg"
    }
  ],
  "japan": [
    {
      "type": "image",
      "src": "assets/gallery/japan-00.jpg"
    },
    {
      "type": "video",
      "src": "assets/japan-video.mp4"
    },
    {
      "type": "image",
      "src": "assets/gallery/japan-02.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/japan-03.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/japan-04.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/japan-05.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/japan-06.jpg"
    },
    {
      "type": "image",
      "src": "assets/gallery/japan-07.jpg"
    }
  ]
};
